module.exports = __webpack_public_path__ + "img/payroll-service-platform-en.a4dab203.png";